import type { PrivacyTranslation } from './types';

/** Hindi. Pending review by native speakers, as the note in the interface says. */
export const privacyHi: PrivacyTranslation = {
  nav: 'निजता',
  title: 'निजता',
  description:
    'आपका वर्कस्पेस बातचीत कितने समय तक रखता है, और जब कोई ग्राहक अपना डेटा माँगे या उसे मिटाने को कहे तो आप क्या कर सकते हैं।',
  retention: {
    title: 'बातचीत कितने समय तक रखी जाती है',
    description:
      'जिन हल हो चुकी बातचीत का आख़िरी संदेश इससे पुराना है, वे अपनी फ़ाइलों समेत Chatwoot और Hamnivo दोनों से मिटा दी जाती हैं। जिन ग्राहकों की कोई बातचीत नहीं बचती, उन्हें भी हटा दिया जाता है। रिपोर्ट के आँकड़े वैसे ही रहते हैं।',
    guide: 'बातचीत रखने की अवधि कैसे काम करती है',
    loading: 'बातचीत रखने की अवधि लोड हो रही है',
    label: 'हल हो चुकी बातचीत रखें',
    hint: 'अवधि आख़िरी संदेश से गिनी जाती है। जिस बातचीत में ग्राहक फिर से लिखता है, वह रखी जाती है।',
    forever: 'जब तक हाथ से न मिटाई जाए',
    periods: {
      d90: '3 महीने',
      d180: '6 महीने',
      d365: '1 साल',
      d730: '2 साल',
      d1095: '3 साल',
      d1825: '5 साल',
      d2555: '7 साल',
    },
    counting: 'बातचीत गिनी जा रही है…',
    preview: 'आज इससे पुरानी हल हो चुकी बातचीत: {{n}}।',
    startsOn:
      'मिटाना {{date}} से शुरू होगा, सहेजने के एक हफ़्ते बाद, ताकि इसे अब भी वापस लिया जा सके। हर मालिक को इसका ईमेल मिलता है।',
    atOnce: 'इससे कुछ भी पहले नहीं मिटता, इसलिए यह तुरंत लागू होता है।',
    save: 'सहेजें',
    saved: 'सहेजा गया।',
    pending:
      '{{date}} से, {{period}} से पुरानी हल हो चुकी बातचीत मिटा दी जाएगी। तब तक आप इसे वापस ले सकते हैं।',
    undo: 'वापस लें',
    undone: 'वापस ले लिया गया। पहले से ज़्यादा कुछ नहीं मिटेगा।',
    progress: 'अब तक मिटाए गए: {{conversations}} बातचीत और {{customers}} ग्राहक।',
    checked: 'आख़िरी बार {{date}} को जाँचा गया।',
    running: 'पुरानी बातचीत मिटाई जा रही है। पहली बार इसमें समय लग सकता है।',
    blocked:
      'मिटाना रुक गया है: Chatwoot ने Hamnivo को बातचीत मिटाने नहीं दी। Hamnivo जिस Chatwoot यूज़र से जुड़ता है, उसका एडमिनिस्ट्रेटर होना ज़रूरी है। Hamnivo में भी कुछ नहीं मिटाया गया। इसे ठीक करते ही मिटाना अपने आप फिर शुरू हो जाएगा।',
    kept: 'ऑर्डर, भुगतान और ऑडिट लॉग रखे जाते हैं: ये कारोबारी रिकॉर्ड हैं।',
  },
  customers: {
    title: 'किसी ग्राहक का डेटा',
    description:
      'किसी ग्राहक को खोजें, ताकि उसकी सारी जानकारी डाउनलोड कर सकें, या उसे हर जगह से मिटा सकें, Chatwoot समेत।',
    guide: 'डाउनलोड करना और मिटाना',
    search: 'ग्राहक खोजें',
    searchHint:
      'नाम, ईमेल पता, फ़ोन नंबर, आपके सिस्टम में उनकी ID, या कोई ग्राहक या बातचीत ID। कम से कम 2 अक्षर।',
    find: 'खोजें',
    searching: 'ग्राहक खोजे जा रहे हैं',
    none: '“{{query}}” से कोई ग्राहक मेल नहीं खाता।',
    results: 'मिले हुए ग्राहक',
    unnamed: 'बिना नाम का विज़िटर',
    erased: 'मिटाया गया',
    lastSeen: 'आख़िरी बार {{date}} को दिखे',
    loading: 'ग्राहक लोड हो रहा है',
    id: 'ग्राहक ID',
    brand: 'ब्रांड',
    conversations: 'बातचीत',
    orders: 'ऑर्डर',
    memories: 'यादें',
    shared: 'उनके Chatwoot संपर्क में किसी दूसरे ब्रांड की बातचीत भी है। वे बातचीत और संपर्क बने रहेंगे।',
    ordersKept: 'उनके ऑर्डर व्यावसायिक रिकॉर्ड के रूप में रहेंगे, उनके नाम और डिलीवरी विवरण के बिना।',
    erasedNote: 'यह ग्राहक मिटा दिया गया है। सिर्फ़ एक गुमनाम रिकॉर्ड बचा है, क्योंकि उनके ऑर्डर उसी से जुड़े हैं।',
    close: 'बंद करें',
    download: 'उनका डेटा डाउनलोड करें',
    erase: 'इस ग्राहक को मिटाएँ',
    exportStarted: 'फ़ाइल तैयार हो रही है। तैयार होने पर यह अनुरोधों में दिखेगी।',
    eraseStarted: 'मिटाना शुरू हो गया है। पूरा होने पर यह अनुरोधों में दिखेगा।',
    reason: {
      label: 'क्यों',
      access_request: 'उन्होंने अपना डेटा माँगा',
      erasure_request: 'उन्होंने मिटाने को कहा',
      other: 'कोई और कारण',
    },
    reference: 'संदर्भ (वैकल्पिक)',
    referenceHint: 'आपका टिकट या केस नंबर। इसमें निजी जानकारी न लिखें।',
    exportTitle: '{{name}} का डेटा डाउनलोड करें',
    exportBody:
      'फ़ाइल में उनकी प्रोफ़ाइल, उनकी बातचीत जैसी उन्होंने देखी, दोनों ओर भेजी गई फ़ाइलें, सहमतियाँ, यादें, ऑर्डर और फ़ीडबैक होते हैं। आंतरिक नोट शामिल नहीं होते। आप इसे 24 घंटे तक डाउनलोड कर सकते हैं, और हर डाउनलोड दर्ज होता है।',
    exportSubmit: 'फ़ाइल तैयार करें',
    eraseTitle: '{{name}} को मिटाएँ',
    eraseBody:
      'इससे Chatwoot में उनकी बातचीत और संपर्क, और Hamnivo में उनसे जुड़ी हर चीज़ मिट जाती है: प्रोफ़ाइल, बातचीत, फ़ाइलें, यादें, फ़ीडबैक और पसंद। इसे वापस नहीं किया जा सकता।',
    eraseKept: 'रहेंगे: ऑर्डर और भुगतान, उनके नाम और डिलीवरी विवरण के बिना, सहमति के रिकॉर्ड और ऑडिट लॉग।',
    confirm: 'पुष्टि के लिए ग्राहक ID लिखें: {{id}}',
    confirmMismatch: 'ग्राहक ID ठीक वैसे ही लिखें जैसे दिखाई गई है।',
    eraseSubmit: 'हर जगह से मिटाएँ',
  },
  requests: {
    title: 'अनुरोध',
    description: 'एक्सपोर्ट और मिटाने के अनुरोध, सबसे नए पहले।',
    loading: 'अनुरोध लोड हो रहे हैं',
    empty: 'अभी तक कोई एक्सपोर्ट या मिटाने का अनुरोध नहीं है।',
    kind: { export: 'एक्सपोर्ट', erase: 'मिटाना' },
    state: {
      queued: 'इंतज़ार में',
      running: 'चल रहा है',
      completed: 'हो गया',
      blocked: 'रुका हुआ',
      failed: 'विफल',
    },
    by: '{{name}} द्वारा',
    download: 'डाउनलोड करें',
    until: '{{date}} तक',
    gone: '24 घंटे बाद मिटा दी गई',
    exported: 'बातचीत: {{conversations}}, फ़ाइलें: {{files}}',
    erasedCounts: 'मिटाई गई बातचीत: {{conversations}}, Chatwoot संपर्क: {{contacts}}',
    blocked:
      'Chatwoot ने Hamnivo को मिटाने नहीं दिया। Hamnivo जिस Chatwoot यूज़र से जुड़ता है, उसे एडमिनिस्ट्रेटर होना चाहिए। Hamnivo में कुछ नहीं मिटाया गया। इसे ठीक करने के बाद फिर से अनुरोध करें।',
    failed: 'यह पूरा नहीं हुआ। फिर से अनुरोध करें।',
  },
};
